// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Weekday from "../../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as FilterType from "../../../app/entity/FilterType.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CampaignStatusType from "../../../app/entity/CampaignStatusType.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getFilterInfo(v) {
  switch (v) {
    case /* AllocationRadius */0 :
        return "Haversine or aerial radius beyond which drivers will be filtered out. Centre of circle is the pickup point.";
    case /* DryRun */1 :
        return " If driver is beyond threshold dry run x (estimated dry run > x km), then dry run ratio is applied where, ratio*estimated dry run > trip distance. Drivers who fulfil this logic get filtered out. Uses actual on road route and not haversine.";
    case /* MaxDryRun */2 :
        return "On road distance from current driver location to pickup beyond which drivers will be filtered out";
    
  }
}

function formatTime(hour, minute) {
  var formattedHour = hour < 10 ? "0" + String(hour) : String(hour);
  var formattedMinute = minute < 10 ? "0" + String(minute) : "" + String(minute);
  return formattedHour.concat(":", formattedMinute);
}

function mapIdstoZones(zones, zone_ids) {
  return List.map((function (z) {
                return z.description;
              }), List.filter(function (z) {
                    return List.exists((function (i) {
                                  return i === z.id;
                                }), zone_ids);
                  })(zones));
}

function mapIdsClusters(clusters, cluster_ids) {
  return List.map((function (c) {
                return c.description;
              }), List.filter(function (c) {
                    return List.exists((function (i) {
                                  return i === c.id;
                                }), cluster_ids);
                  })(clusters));
}

function getCreatorInfo(creatorInfo) {
  return {
          actor: {
            name: creatorInfo.actor.name,
            email_id: creatorInfo.actor.email_id
          },
          time: Timestamp$Catalyst.toString(creatorInfo.time, "DD-MMM-YYYY")
        };
}

function getApproverInfo(approverInfo) {
  if (approverInfo !== undefined) {
    return {
            actor: {
              name: approverInfo.actor.name,
              email_id: approverInfo.actor.email_id
            },
            time: Timestamp$Catalyst.toString(approverInfo.time, "DD-MMM-YYYY")
          };
  }
  
}

function getViewModel(campaign, zones, clusters) {
  console.log("**********", campaign);
  var time = campaign.effective_till;
  var match = List.length(campaign.days_of_week);
  var tmp;
  if (match !== 7) {
    var days_in_string = List.map(Weekday.toString, campaign.days_of_week);
    tmp = ListUtils$Catalyst.toString(days_in_string, (function (a) {
            return $$String.sub(a, 0, 3);
          }), undefined, undefined);
  } else {
    tmp = "All";
  }
  var match$1 = campaign.day_start_hour;
  var match$2 = campaign.day_start_min;
  var match$3 = campaign.day_end_hour;
  var match$4 = campaign.day_end_min;
  var match$5 = campaign.sub_type;
  var tmp$1;
  if (match$5 !== 1) {
    var v = campaign.values.auto;
    var v$1 = campaign.values.manual;
    tmp$1 = {
      left_value: v !== undefined ? v : -1,
      right_value: v$1 !== undefined ? v$1 : -1
    };
  } else {
    var v$2 = campaign.values.threshold;
    var v$3 = campaign.values.ratio;
    tmp$1 = {
      left_value: v$2 !== undefined ? v$2 : -1,
      right_value: v$3 !== undefined ? v$3 : -1
    };
  }
  var clusters$1 = campaign.cluster_ids;
  var tmp$2;
  if (clusters$1 !== undefined) {
    var match$6 = clusters$1.length;
    tmp$2 = match$6 !== 0 ? "Cluster" : "Zone";
  } else {
    tmp$2 = "Zone";
  }
  return {
          id: campaign.id,
          name: campaign.name,
          geo_region_id: campaign.geo_region_id,
          vehicle_id: campaign.vehicle_id,
          _type: campaign._type,
          sub_type: FilterType.toDisplayString(campaign.sub_type),
          zones: mapIdstoZones(zones, $$Array.to_list(campaign.zone_ids)),
          clusters: mapIdsClusters(clusters, $$Array.to_list(Belt_Option.getWithDefault(campaign.cluster_ids, []))),
          status: CampaignStatusType.toString(campaign.status),
          priority: campaign.priority,
          pending_priority: campaign.pending_priority,
          effective_from: Timestamp$Catalyst.toString(campaign.effective_from, "DD-MMM-YYYY"),
          effective_till: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD-MMM-YYYY") : "N/A",
          days_of_week: tmp,
          day_start_time: match$1 !== undefined && match$2 !== undefined ? formatTime(match$1, match$2) : "N/A",
          day_end_time: match$3 !== undefined && match$4 !== undefined ? formatTime(match$3, match$4) : "N/A",
          filter: tmp$1,
          creation_info: getCreatorInfo(campaign.creation_info),
          approval_info: getApproverInfo(campaign.approval_info),
          filter_info: getFilterInfo(campaign.sub_type),
          campaign_type: tmp$2
        };
}

var VMMapper = {
  getViewModel: getViewModel
};

export {
  getFilterInfo ,
  formatTime ,
  mapIdstoZones ,
  mapIdsClusters ,
  getCreatorInfo ,
  getApproverInfo ,
  VMMapper ,
  
}
/* Timestamp-Catalyst Not a pure module */
